export const MOSCOW_TIME_ZONE = 'Europe/Moscow';

const MOSCOW_DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  timeZone: MOSCOW_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const MOSCOW_DATETIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  timeZone: MOSCOW_TIME_ZONE,
  hourCycle: 'h23',
  hour12: false,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

function partsMap(formatter: Intl.DateTimeFormat, ms: number): Record<string, string> {
  const map: Record<string, string> = {};
  for (const part of formatter.formatToParts(new Date(ms))) {
    if (part.type !== 'literal') {
      map[part.type] = part.value;
    }
  }
  return map;
}

/** Календарная дата YYYY-MM-DD в Europe/Moscow. */
export function isoDateFromMs(ms: number): string {
  const { year, month, day } = partsMap(MOSCOW_DATE_FORMATTER, ms);
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

/** Смещение Москвы от UTC в этот момент (восток — положительное). */
function moscowOffsetMs(instant: number): number {
  const map = partsMap(MOSCOW_DATETIME_FORMATTER, instant);
  const asUtc = Date.UTC(
    Number(map.year),
    Number(map.month) - 1,
    Number(map.day),
    Number(map.hour),
    Number(map.minute),
    Number(map.second),
  );
  return asUtc - instant;
}

function moscowWallTimeToUtc(
  year: number,
  month: number,
  day: number,
  hour = 0,
  minute = 0,
  second = 0,
  ms = 0,
): number {
  const asUtc = Date.UTC(year, month - 1, day, hour, minute, second, ms);
  const instant = asUtc - moscowOffsetMs(asUtc);
  return asUtc - moscowOffsetMs(instant);
}

function startOfMoscowDayMs(ms: number): number {
  const [year, month, day] = isoDateFromMs(ms).split('-').map(Number);
  return moscowWallTimeToUtc(year, month, day);
}

/** Ближайшая полночь МСК: текущая, если now уже ровно 00:00:00, иначе следующая. */
export function nextMoscowMidnightMs(now: number): number {
  const startToday = startOfMoscowDayMs(now);
  if (now <= startToday) {
    return startToday;
  }
  return startOfMoscowDayMs(startToday + 24 * 60 * 60 * 1000);
}

export function msUntilNextMoscowMidnight(now: number): number {
  return Math.max(0, nextMoscowMidnightMs(now) - now);
}

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

/** Обратный отсчёт `HH:MM:SS`. */
export function formatCountdownHms(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`;
}
